import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import ApiData from "../../../api/ApiData";
import RolesState from "../../../api/RolesState";
import Loader from "../../Loader";
import { BtnOutlineV4 } from "../../UI/button/BtnOutlineV4";
import {
  clientLkUsersNeedProductions,
  formatClientLkUserFio,
  formatClientLkYesNo,
  mapProductionIdsToNames,
} from "../../../utils/clientLkUsersUtils";
import { CompanyClientLkResetPasswordModal } from "./CompanyClientLkResetPasswordModal";

const GRID_CLASS = "cc-v4-soft-grid client-lk-employees-grid";

export const CompanyClientLkEmployeesPanel = observer(({ companyId }) => {
  const [resetUser, setResetUser] = useState(null);
  const sameCompany =
    companyId && ApiData.clientLkUsersCompanyId === companyId;
  const payload = sameCompany ? ApiData.clientLkUsersPayload : null;

  useEffect(() => {
    if (!payload?.registered_in_client_lk || !companyId) {
      return;
    }
    const users = payload.users ?? [];
    if (
      clientLkUsersNeedProductions(users, ApiData.company.productions) &&
      RolesState.production_id
    ) {
      ApiData.getProduction();
    }
  }, [companyId, payload?.registered_in_client_lk, payload?.users]);

  if (ApiData.clientLkUsersLoading && !sameCompany) {
    return <Loader />;
  }

  if (!sameCompany || payload === null) {
    return (
      <p className="grey_info">Данные личного кабинета клиента недоступны</p>
    );
  }

  if (!payload.registered_in_client_lk) {
    return (
      <p className="grey_info">
        Использование личного кабинета DMC не зарегистрировано
      </p>
    );
  }

  const users = payload.users ?? [];
  const productions = ApiData.company.productions ?? [];
  const rowClass = `cc-v4-soft-row ${GRID_CLASS} reports-soft-row client-lk-employees-row`;

  return (
    <>
      <div className="card table-container company-card-v4-soft-table client-lk-employees-panel">
        <div className="cc-v4-soft-list-root">
          <div className={`cc-v4-soft-header ${GRID_CLASS}`}>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">ФИО</span>
            </span>
            <span className="cc-v4-soft-th-static">
              <span className="cc-v4-soft-th-label">Телефон</span>
            </span>
            <span className="cc-v4-soft-th-static client-lk-col-email">
              <span className="cc-v4-soft-th-label">e-mail</span>
            </span>
            <span className="cc-v4-soft-th-static client-lk-col-productions">
              <span className="cc-v4-soft-th-label">Площадки</span>
            </span>
            <span className="cc-v4-soft-th-static client-lk-col-active">
              <span className="cc-v4-soft-th-label">Активен</span>
            </span>
            <span className="cc-v4-soft-th-static client-lk-col-actions">
              <span className="cc-v4-soft-th-label">Действие</span>
            </span>
          </div>
          <div className="cc-v4-soft-body">
            {users.length > 0 ? (
              users.map((user) => (
                <div key={user.id} className={rowClass}>
                  <span className="reports-cell">
                    {formatClientLkUserFio(user)}
                  </span>
                  <span className="reports-cell company-card-v4-mono">
                    {user.phone || "—"}
                  </span>
                  <span className="reports-cell client-lk-col-email">
                    {user.email || "—"}
                  </span>
                  <span className="reports-cell client-lk-col-productions">
                    {mapProductionIdsToNames(user.id_production, productions)}
                  </span>
                  <span className="reports-cell client-lk-col-active">
                    {formatClientLkYesNo(user.is_active)}
                  </span>
                  <span className="reports-cell client-lk-col-actions">
                    <BtnOutlineV4
                      text="Сброс пароля"
                      onClick={() => setResetUser(user)}
                    />
                  </span>
                </div>
              ))
            ) : (
              <p className="grey_info">Сотрудники не найдены</p>
            )}
          </div>
        </div>
      </div>
      {resetUser ? (
        <CompanyClientLkResetPasswordModal
          companyId={companyId}
          user={resetUser}
          onClose={() => setResetUser(null)}
        />
      ) : null}
    </>
  );
});
